// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface RutterConfigOut {}

export const RutterConfigOutSerializer = {
  _fromJsonObject(_object: any): RutterConfigOut {
    return {};
  },

  _toJsonObject(_self: RutterConfigOut): any {
    return {};
  },
};
